import { Box, Stack, Tooltip, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import StatusChip from 'src/components/StatusChip';
import {
  getDeployableArtifactTypeColor,
  getDeployableArtifactTypeLabel,
} from 'src/utils/enums/deployableArtifactType';
import { isPortalGenerated } from 'src/utils/enums/originalSource';

const SMALL_CHIP_SX = { height: 20, fontSize: '0.65rem' };
const GENERATED_COLOR = '#87C8E0';

// One line per artifact: the form the policy takes, a shield when we are the ones who generated it,
// and the hash that ties the two together once a generated file reaches a device. A list with no
// room for hashes can leave them out.
const DeployableArtifactList = ({ artifacts, emptyText = '-', dense = false, showHash = true }) => {
  if (!artifacts?.length) {
    return <Typography variant="caption">{emptyText}</Typography>;
  }

  return (
    <Stack gap={dense ? 0.5 : 1}>
      {artifacts.map(artifact => {
        const typeColor = getDeployableArtifactTypeColor(artifact.artifactType);

        return (
          <Stack key={artifact.id} gap={0.25} sx={{ minWidth: 0 }}>
            <Stack direction="row" alignItems="center" gap={0.75} flexWrap="wrap">
              <StatusChip
                label={getDeployableArtifactTypeLabel(artifact.artifactType)}
                color={typeColor}
                backgroundColor={`${typeColor}1F`}
                sx={SMALL_CHIP_SX}
              />
              {isPortalGenerated(artifact.originalSource) ? (
                <Tooltip title="This is being managed by appcontrol.ai">
                  <Box component="span" display="inline-flex">
                    <Iconify
                      icon="mdi:shield-check-outline"
                      width={16}
                      height={16}
                      color={GENERATED_COLOR}
                    />
                  </Box>
                </Tooltip>
              ) : null}
              {artifact.fileName ? (
                <Typography variant="caption" sx={{ color: '#D1D5DB', wordBreak: 'break-all' }}>
                  {artifact.fileName}
                </Typography>
              ) : null}
            </Stack>
            {showHash ? (
              <Typography
                variant="caption"
                sx={{
                  fontFamily: 'monospace',
                  fontSize: '0.65rem',
                  color: '#9CA3AF',
                  wordBreak: 'break-all',
                }}>
                {artifact.artifactHash || 'No hash recorded'}
              </Typography>
            ) : null}
          </Stack>
        );
      })}
    </Stack>
  );
};

export default DeployableArtifactList;
